<script lang="ts" setup>
const { createEvent } = useAnalytics()
const { t } = useI18n()
const guards = useGuards()

guards.visitorOnly()

onMounted(async () => {
  try {
    await guards.extensionOnly()

    /*
    await sendMessage({
      action: 'extension:authenticate',
      opaqueToken: authStore.opaqueToken,
    })
    */

    createEvent({ name: '[Auth] Login Chrome Extension' })

    window.close()
  }
  catch (error) {
    console.error(error)
  }
})
</script>

<template>
  <UContainer class="mx-auto flex max-w-md flex-col items-center space-y-4 md:space-y-6">
    <BasePower class="mb-4" />

    <BaseHeading
      :description="t('description')"
      tag="h1"
      :title="t('title')"
    />

    <BaseSpinner class="size-10 md:size-12" />
  </UContainer>
</template>

<i18n lang="json">
{
  "en": {
    "description": "If the process takes too long, feel free to contact us.",
    "title": "Connecting to the extension…"
  },
  "es": {
    "description": "Si el proceso tarda demasiado, no dudes en contactarnos.",
    "title": "Conectando a la extensión…"
  },
  "fr": {
    "description": "Si le processus prend trop de temps, n'hésitez pas à nous contacter.",
    "title": "Connexion à l'extension…"
  }
}
</i18n>
